<template>
  <v-card elevation="2">
    <v-tabs v-model="tab" bg-color="primary" dark>
      <v-tab value="overview">Overview</v-tab>
      <v-tab value="performance">Performance</v-tab>
      <v-tab value="dimensions">Dimensions</v-tab>
      <v-tab value="features">Features</v-tab>
      <v-tab value="equipment">Equipment</v-tab>
      <v-tab value="warranty">Warranty</v-tab>
    </v-tabs>

    <v-tabs-window v-model="tab">
      <v-tabs-window-item value="overview">
        <v-card-text>
          <v-row>
            <v-col cols="12" md="6">
              <v-list density="compact">
                <v-list-item>
                  <template v-slot:prepend>
                    <v-icon>mdi-car</v-icon>
                  </template>
                  <v-list-item-title>Body Style</v-list-item-title>
                  <v-tooltip location="top">
                    <template v-slot:activator="{ props: tooltipProps }">
                      <v-list-item-subtitle v-bind="tooltipProps">{{
                        getSpec('Summary', 'Body Style')
                      }}</v-list-item-subtitle>
                    </template>
                    <span>{{ getSpec('Summary', 'Body Style') }}</span>
                  </v-tooltip>
                </v-list-item>
                <v-list-item>
                  <template v-slot:prepend>
                    <v-icon>mdi-engine</v-icon>
                  </template>
                  <v-list-item-title>Engine</v-list-item-title>
                  <v-tooltip location="top">
                    <template v-slot:activator="{ props: tooltipProps }">
                      <v-list-item-subtitle v-bind="tooltipProps">{{
                        getSpec('Engine', 'Engine Type')
                      }}</v-list-item-subtitle>
                    </template>
                    <span>{{ getSpec('Engine', 'Engine Type') }}</span>
                  </v-tooltip>
                </v-list-item>
                <v-list-item>
                  <template v-slot:prepend>
                    <v-icon>mdi-cog</v-icon>
                  </template>
                  <v-list-item-title>Transmission</v-list-item-title>
                  <v-tooltip location="top">
                    <template v-slot:activator="{ props: tooltipProps }">
                      <v-list-item-subtitle v-bind="tooltipProps">{{
                        getSpec('Transmission', 'Trans Description')
                      }}</v-list-item-subtitle>
                    </template>
                    <span>{{ getSpec('Transmission', 'Trans Description') }}</span>
                  </v-tooltip>
                </v-list-item>
                <v-list-item>
                  <template v-slot:prepend>
                    <v-icon>mdi-axis-arrow</v-icon>
                  </template>
                  <v-list-item-title>Drivetrain</v-list-item-title>
                  <v-tooltip location="top">
                    <template v-slot:activator="{ props: tooltipProps }">
                      <v-list-item-subtitle v-bind="tooltipProps">{{
                        getSpec('Transmission', 'Drivetrain')
                      }}</v-list-item-subtitle>
                    </template>
                    <span>{{ getSpec('Transmission', 'Drivetrain') }}</span>
                  </v-tooltip>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col cols="12" md="6">
              <v-list density="compact">
                <v-list-item>
                  <template v-slot:prepend>
                    <v-icon>mdi-seat</v-icon>
                  </template>
                  <v-list-item-title>Seating Capacity</v-list-item-title>
                  <v-tooltip location="top">
                    <template v-slot:activator="{ props: tooltipProps }">
                      <v-list-item-subtitle v-bind="tooltipProps">{{
                        getSpec('Interior Dimensions', 'Passenger Capacity')
                      }}</v-list-item-subtitle>
                    </template>
                    <span>{{ getSpec('Interior Dimensions', 'Passenger Capacity') }}</span>
                  </v-tooltip>
                </v-list-item>
                <v-list-item>
                  <template v-slot:prepend>
                    <v-icon>mdi-gas-station</v-icon>
                  </template>
                  <v-list-item-title>Fuel Type</v-list-item-title>
                  <v-tooltip location="top">
                    <template v-slot:activator="{ props: tooltipProps }">
                      <v-list-item-subtitle v-bind="tooltipProps">{{
                        getSpec('Engine', 'Fuel System')
                      }}</v-list-item-subtitle>
                    </template>
                    <span>{{ getSpec('Engine', 'Fuel System') }}</span>
                  </v-tooltip>
                </v-list-item>
                <v-list-item>
                  <template v-slot:prepend>
                    <v-icon>mdi-speedometer</v-icon>
                  </template>
                  <v-list-item-title>Combined MPG</v-list-item-title>
                  <v-tooltip location="top">
                    <template v-slot:activator="{ props: tooltipProps }">
                      <v-list-item-subtitle v-bind="tooltipProps">{{
                        getSpec('Mileage', 'Fuel Economy Est-Combined')
                      }}</v-list-item-subtitle>
                    </template>
                    <span>{{ getSpec('Mileage', 'Fuel Economy Est-Combined') }}</span>
                  </v-tooltip>
                </v-list-item>
                <v-list-item>
                  <template v-slot:prepend>
                    <v-icon>mdi-currency-usd</v-icon>
                  </template>
                  <v-list-item-title>Starting MSRP</v-list-item-title>
                  <v-tooltip location="top">
                    <template v-slot:activator="{ props: tooltipProps }">
                      <v-list-item-subtitle v-bind="tooltipProps">{{
                        formatCurrency(trim?.baseMsrp || trim?.price || 0)
                      }}</v-list-item-subtitle>
                    </template>
                    <span>{{ formatCurrency(trim?.baseMsrp || trim?.price || 0) }}</span>
                  </v-tooltip>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>
      </v-tabs-window-item>

      <v-tabs-window-item value="performance">
        <v-card-text>
          <h3 class="mb-4">Engine Specifications</h3>
          <v-divider class="mb-4"></v-divider>
          <v-list density="compact">
            <v-list-item v-for="item in getSpecItems('Engine')" :key="item">
              <v-tooltip location="top">
                <template v-slot:activator="{ props: tooltipProps }">
                  <v-list-item-title v-bind="tooltipProps">{{
                    parseSpecItemLocal(item).label
                  }}</v-list-item-title>
                </template>
                <span>{{ parseSpecItemLocal(item).label }}</span>
              </v-tooltip>
              <v-tooltip location="top">
                <template v-slot:activator="{ props: tooltipProps }">
                  <v-list-item-subtitle v-bind="tooltipProps">{{
                    parseSpecItemLocal(item).value
                  }}</v-list-item-subtitle>
                </template>
                <span>{{ parseSpecItemLocal(item).value }}</span>
              </v-tooltip>
            </v-list-item>
          </v-list>

          <h3 class="mb-4 mt-6">Transmission</h3>
          <v-divider class="mb-4"></v-divider>
          <v-list density="compact">
            <v-list-item
              v-for="item in getSpecItems('Transmission')"
              :key="item"
            >
              <v-tooltip location="top">
                <template v-slot:activator="{ props: tooltipProps }">
                  <v-list-item-title v-bind="tooltipProps">{{
                    parseSpecItemLocal(item).label
                  }}</v-list-item-title>
                </template>
                <span>{{ parseSpecItemLocal(item).label }}</span>
              </v-tooltip>
              <v-tooltip location="top">
                <template v-slot:activator="{ props: tooltipProps }">
                  <v-list-item-subtitle v-bind="tooltipProps">{{
                    parseSpecItemLocal(item).value
                  }}</v-list-item-subtitle>
                </template>
                <span>{{ parseSpecItemLocal(item).value }}</span>
              </v-tooltip>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-tabs-window-item>

      <v-tabs-window-item value="dimensions">
        <v-card-text>
          <h3 class="mb-4">Exterior Dimensions</h3>
          <v-divider class="mb-4"></v-divider>
          <v-list density="compact">
            <v-list-item
              v-for="item in getSpecItems('Exterior Dimensions')"
              :key="item"
            >
              <v-tooltip location="top">
                <template v-slot:activator="{ props: tooltipProps }">
                  <v-list-item-title v-bind="tooltipProps">{{
                    parseSpecItemLocal(item).label
                  }}</v-list-item-title>
                </template>
                <span>{{ parseSpecItemLocal(item).label }}</span>
              </v-tooltip>
              <v-tooltip location="top">
                <template v-slot:activator="{ props: tooltipProps }">
                  <v-list-item-subtitle v-bind="tooltipProps">{{
                    parseSpecItemLocal(item).value
                  }}</v-list-item-subtitle>
                </template>
                <span>{{ parseSpecItemLocal(item).value }}</span>
              </v-tooltip>
            </v-list-item>
          </v-list>

          <h3 class="mb-4 mt-6">Interior Dimensions</h3>
          <v-divider class="mb-4"></v-divider>
          <v-list density="compact">
            <v-list-item
              v-for="item in getSpecItems('Interior Dimensions')"
              :key="item"
            >
              <v-tooltip location="top">
                <template v-slot:activator="{ props: tooltipProps }">
                  <v-list-item-title v-bind="tooltipProps">{{
                    parseSpecItemLocal(item).label
                  }}</v-list-item-title>
                </template>
                <span>{{ parseSpecItemLocal(item).label }}</span>
              </v-tooltip>
              <v-tooltip location="top">
                <template v-slot:activator="{ props: tooltipProps }">
                  <v-list-item-subtitle v-bind="tooltipProps">{{
                    parseSpecItemLocal(item).value
                  }}</v-list-item-subtitle>
                </template>
                <span>{{ parseSpecItemLocal(item).value }}</span>
              </v-tooltip>
            </v-list-item>
          </v-list>

          <h3 class="mb-4 mt-6">Weight Information</h3>
          <v-divider class="mb-4"></v-divider>
          <v-list density="compact">
            <v-list-item
              v-for="item in getSpecItems('Weight Information')"
              :key="item"
            >
              <v-tooltip location="top">
                <template v-slot:activator="{ props: tooltipProps }">
                  <v-list-item-title v-bind="tooltipProps">{{
                    parseSpecItemLocal(item).label
                  }}</v-list-item-title>
                </template>
                <span>{{ parseSpecItemLocal(item).label }}</span>
              </v-tooltip>
              <v-tooltip location="top">
                <template v-slot:activator="{ props: tooltipProps }">
                  <v-list-item-subtitle v-bind="tooltipProps">{{
                    parseSpecItemLocal(item).value
                  }}</v-list-item-subtitle>
                </template>
                <span>{{ parseSpecItemLocal(item).value }}</span>
              </v-tooltip>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-tabs-window-item>

      <v-tabs-window-item value="features">
        <v-card-text>
          <v-expansion-panels variant="accordion">
            <v-expansion-panel
              v-for="(category, idx) in featureCategories"
              :key="idx"
              :title="category.name"
            >
              <v-expansion-panel-text>
                <v-list density="compact">
                  <v-list-item
                    v-for="item in getFeatures(category.key)"
                    :key="item"
                  >
                    <template v-slot:prepend>
                      <v-icon color="primary" size="small">mdi-check</v-icon>
                    </template>
                    <v-tooltip location="top">
                      <template v-slot:activator="{ props: tooltipProps }">
                        <v-list-item-title v-bind="tooltipProps">{{ item }}</v-list-item-title>
                      </template>
                      <span>{{ item }}</span>
                    </v-tooltip>
                  </v-list-item>
                </v-list>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
      </v-tabs-window-item>

      <v-tabs-window-item value="equipment">
        <v-card-text>
          <h3 class="mb-4">Standard Equipment</h3>
          <v-divider class="mb-4"></v-divider>
          <v-expansion-panels variant="accordion">
            <template
              v-for="(equipData, key) in trim?.standardEquipment"
              :key="key"
            >
              <v-expansion-panel
                v-if="equipData?.items?.length"
                :title="formatCategory(String(key))"
              >
                <v-expansion-panel-text>
                  <v-list density="compact">
                    <v-list-item v-for="item in equipData.items" :key="item">
                      <template v-slot:prepend>
                        <v-icon color="success" size="small"
                          >mdi-check-circle</v-icon
                        >
                      </template>
                      <v-tooltip location="top">
                      <template v-slot:activator="{ props: tooltipProps }">
                        <v-list-item-title v-bind="tooltipProps">{{ item }}</v-list-item-title>
                      </template>
                      <span>{{ item }}</span>
                    </v-tooltip>
                    </v-list-item>
                  </v-list>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </template>
          </v-expansion-panels>

          <template v-if="hasAvailableOptions">
            <h3 class="mb-4 mt-6">Available Options</h3>
            <v-divider class="mb-4"></v-divider>
            <v-expansion-panels variant="accordion">
              <template
                v-for="(optionData, key) in trim?.availableOptions"
                :key="key"
              >
                <v-expansion-panel
                  v-if="optionData?.items?.length"
                  :title="formatCategory(String(key))"
                >
                  <v-expansion-panel-text>
                    <v-list density="compact">
                      <v-list-item v-for="item in optionData.items" :key="item">
                        <template v-slot:prepend>
                          <v-icon color="info" size="small"
                            >mdi-plus-circle</v-icon
                          >
                        </template>
                        <v-tooltip location="top">
                      <template v-slot:activator="{ props: tooltipProps }">
                        <v-list-item-title v-bind="tooltipProps">{{ item }}</v-list-item-title>
                      </template>
                      <span>{{ item }}</span>
                    </v-tooltip>
                      </v-list-item>
                    </v-list>
                  </v-expansion-panel-text>
                </v-expansion-panel>
              </template>
            </v-expansion-panels>
          </template>
        </v-card-text>
      </v-tabs-window-item>

      <v-tabs-window-item value="warranty">
        <v-card-text>
          <h3 class="mb-4">Warranty Information</h3>
          <v-divider class="mb-4"></v-divider>
          <v-list density="comfortable">
            <v-list-item v-for="item in getWarrantyItems()" :key="item">
              <template v-slot:prepend>
                <v-icon color="primary">mdi-shield-check</v-icon>
              </template>
              <v-list-item-title class="text-wrap">{{
                item
              }}</v-list-item-title>
            </v-list-item>
          </v-list>

          <v-alert type="info" variant="tonal" class="mt-4">
            <v-alert-title>Note</v-alert-title>
            Warranty coverage may vary. Please consult with your dealer for
            complete warranty details and terms.
          </v-alert>
        </v-card-text>
      </v-tabs-window-item>
    </v-tabs-window>
  </v-card>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { formatCurrency } from '@/utils'
import { parseSpecValue, parseSpecItem } from '@/utils/modelDetails'
import type { TrimData, StandardEquipment } from '@/types'

interface EquipmentData {
  items?: string[]
}

const props = defineProps<{
  trim: TrimData | null
}>()

const tab = ref('overview')

const featureCategories = [
  { name: 'Safety Features', key: 'SAFETY' },
  { name: 'Comfort & Convenience', key: 'COMFORT' },
  { name: 'Interior Features', key: 'INTERIOR' },
  { name: 'Exterior Features', key: 'EXTERIOR' },
  { name: 'Technology', key: 'TECHNOLOGY' },
  { name: 'Mechanical', key: 'MECHANICAL' },
]

const hasAvailableOptions = computed(() => {
  if (!props.trim?.availableOptions) return false
  return Object.values(props.trim.availableOptions).some(
    (opt: EquipmentData) => opt?.items && opt.items.length > 0,
  )
})

const sanitizeHtml = (text: string): string => {
  if (!text) return ''
  return text
    .replace(/<[^>]*>/g, '') // Remove HTML tags
    .replace(/&nbsp;/g, ' ') // Replace &nbsp; with space
    .replace(/&amp;/g, '&') // Replace &amp; with &
    .replace(/&lt;/g, '<') // Replace &lt; with <
    .replace(/&gt;/g, '>') // Replace &gt; with >
    .replace(/&quot;/g, '"') // Replace &quot; with "
    .replace(/&#39;/g, "'") // Replace &#39; with '
    .replace(/\s+/g, ' ') // Replace multiple spaces with single space
    .trim()
}

const getSpec = (category: string, searchTerm: string): string => {
  const items = props.trim?.technicalSpecification?.[category]?.items || []
  const item = items.find((i: string) => i.includes(searchTerm))
  if (item) {
    const value = parseSpecValue(item)
    return sanitizeHtml(value)
  }
  return 'N/A'
}

const getSpecItems = (category: string): string[] => {
  return props.trim?.technicalSpecification?.[category]?.items || []
}

const parseSpecItemLocal = (item: string) => {
  const parsed = parseSpecItem(item, false)
  if (typeof parsed === 'object') {
    return {
      label: sanitizeHtml(parsed.label),
      value: sanitizeHtml(parsed.value),
    }
  }
  return {
    label: sanitizeHtml(''),
    value: sanitizeHtml(parsed),
  }
}

const getFeatures = (category: string): string[] => {
  return props.trim?.standardEquipment?.[category]?.items || []
}

const getWarrantyItems = (): string[] => {
  const consumerInfo = props.trim?.consumerInformation as
    | StandardEquipment
    | undefined
  const warrantyData = consumerInfo?.['Warranty'] as
    | { items?: string[] }
    | undefined
  return warrantyData?.items || []
}

const formatCategory = (key: string): string => {
  return key
    .split('_')
    .map(word => word.charAt(0) + word.slice(1).toLowerCase())
    .join(' ')
}
</script>

<style scoped>
:deep(.v-expansion-panel-title) {
  font-weight: 500;
}

:deep(.v-list-item-subtitle) {
  white-space: normal;
  opacity: 0.9;
}

:deep(.v-expansion-panel-text__wrapper) {
  padding: 16px 24px;
}
</style>
